import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WelcomeContainer } from './welcome.style';
import LoginForm from '../../../components/login';
import WithEmailLoginForm from '../../../components/login/withEmail';
var Welcome = function () {
    var navigate = useNavigate();
    var _a = useState(false), nextStepEmailForm = _a[0], setNextStepEmailForm = _a[1];
    var handleEmailLoginClick = function () {
        setNextStepEmailForm(true);
    };
    var handleStart = function () {
        navigate('/onboarding/account-setup');
    };
    var onClose = function () {
        setNextStepEmailForm(false);
    };
    console.log("welcome component");
    return (_jsx(WelcomeContainer, { children: nextStepEmailForm ? _jsx(WithEmailLoginForm, { onClose: onClose }) : _jsx(LoginForm, { handleEmailLoginClick: handleEmailLoginClick }) }));
};
export default Welcome;
